<template>
  <b-modal
    title="Invite User"
    ref="invite-user-modal"
    id="invite-user-modal"
    size="lg"
    ok-title="Invite"
    @ok="inviteUser"
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <validation-observer ref="inviteRule" tag="form">
        <b-form-group label-for="email">
          Email<span class="text-danger">*</span>
          <validation-provider
            #default="{ errors }"
            name="Email"
            rules="required|email"
          >
            <b-form-input
              id="email"
              v-model="user.email"
              type="email"
              :state="errors.length > 0 ? false : null"
              placeholder="test@gmail.com"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="name">
          Name<span class="text-danger">*</span>
          <validation-provider
            #default="{ errors }"
            name="Name"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="user.name"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <validation-provider #default="{ errors }" name="Account" rules="required" v-if="hasSuperAdminRole()">
          <div class="d-flex align-items-center mt-3">
            Account <span class="text-danger">*</span>
            <vue-select
              id="account"
              v-model="user.account"
              :options="accounts"
              :state="errors.length > 0 ? false : null"
              :reduce="(option) => option.id"
              label="title"
              placeholder="Account"
              class="half-width float-left ml-1"
            />
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider #default="{ errors }" name="Role" rules="required">
          <div class="d-flex align-items-center mt-3">
            Role <span class="text-danger">*</span>
            <vue-select
              id="role"
              v-model="user.roleId"
              :options="roles"
              :state="errors.length > 0 ? false : null"
              :reduce="(option) => option.id"
              label="name"
              placeholder="Role"
              class="half-width float-left ml-1"
            />
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import CISUserService from "@/services/cis-user.service";
import CommonService from "@/services/common.service";
import CISAccountService from "@/services/cis-account.service";

import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "InviteUserModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      roles: [],
      user: {},
      required,
      email,
      accounts: [],
    };
  },
  methods: {
    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.inviteRule.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    async inviteUser(e) {
      e.preventDefault();
      await this.checkInfo();

      // email 있는지 확인
      const checkMail = await CISUserService.check(this.user.email);

      // aria-hidden focus error
      // this.$bvModal.hide("invite-user-modal");
      // document.getElementById('invite-user-modal').blur();
      // document.getElementById('invite-user-modal___BV_modal_outer_').ariaHidden=false;
      // document.getElementById('invite-user-modal').style.display = "none";
      // document.getElementById('invite-user-modal').style.disableAutoFocus = true;
      
      
      if(checkMail.data.data == null){
        if ( !this.user.account ) {
          this.user.account = useJwt.getUserData().adacctId
        }
        
        //없다면 새로운 user create
        this.$swal({
          title: "Invite New user",
          html: "Email [" + this.user.email + "] <br>User named [" + this.user.name + "]<br>&nbsp;",
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
          padding: "1rem"
        }).then(async (result) => {
          if (result.isConfirmed) {
            const response = await CISUserService.createUser(this.user);
            if (response && response.status === 200) {
              this.user = {};
              this.$bvModal.hide("invite-user-modal");
              this.refreshData();
              this.$parent.setMemNum();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Successfully invited!`,
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message || "Unknown error",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                },
              });
            }
          }
        });
      }else{
      // 있다면 alert
        this.user = {};
        this.$bvModal.hide("invite-user-modal");
        this.refreshData();
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Already invited! Check Email!`,
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      }

    },
    async loadRoles() {
      var roleId =  useJwt.getUserData().role.id
      if( roleId == 1 ){
        console.log('super')
        const response = await CommonService.getRolesSuper();
        if (response && response.data.success) {
          this.roles = response.data.data;
          console.log(this.roles)
        }
      }else{
        console.log('no super')
        const response = await CommonService.getRoles();
        if (response && response.data.success) {
          this.roles = response.data.data;
          console.log(this.roles)
        }
      }
      
    },
    async loadAccounts() {
      const response = await CISAccountService.accountList();
      if (response && response.data.success) {
        this.accounts = response.data.data;
        console.log(this.accounts)
      }
    },


  },
  created() {
    this.loadRoles();
    this.loadAccounts();
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>